<template>
  <div id="sig-container" class="full form-horizontal">
    <div class="loader" v-if="loading">
      <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
    </div>
    <contacto />
    <table-component :data="acuerdos_pago" pagination @click-event="clickEvent">
      <table-column
        slot="label"
        :label="'ID'"
        v-bind:value="'id'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Fecha de Llamada'"
        v-bind:value="'hora_inicio'"
        :filter="'formatDate'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Fecha Primer Pago'"
        v-bind:value="'fecha_primer_pago'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Dia de Pago'"
        v-bind:value="'dia_pago'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Cuotas'"
        v-bind:value="'cuotas'"
        :customClass="'text-right'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Valor cuota'"
        v-bind:value="'valor_cuota'"
        :filter="'numberFormat'"
        :customClass="'text-right'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Valor cuota inicial'"
        v-bind:value="'valor_cuota_inicial'"
        :filter="'numberFormat'"
        :customClass="'text-right'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Monto Congelado'"
        v-bind:value="'monto_congelar'"
        :filter="'numberFormat'"
        :customClass="'text-right'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Valor Compromiso'"
        v-bind:value="'valor_compromiso'"
        :filter="'numberFormat'"
        :customClass="'text-right'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Tipo de acuerdo'"
        v-bind:value="'tipo'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Estado'"
        v-bind:value="'estado'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Usuario modificación'"
        v-bind:value="'username'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Fecha modificación'"
        v-bind:value="'updated_at'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Saldo desuento de capital'"
        v-bind:value="'condonacion_capital'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Porcentaje desuento de capital'"
        v-bind:value="'porcentaje_condonacion_capital'"
      ></table-column>
      <table-column slot="label" :label="'Acciones'" :icon="'fa'">
        <template
          slot="icon"
          :icon="'fa fa-cog'"
          :class="'btn btn-sm btn-primary'"
          :slug="'editar-acuerdo'"
        ></template>
        <template
          slot="icon"
          :icon="'fa fa-regular fa-envelope'"
          :class="'btn btn-sm btn-primary'"
          :slug="'enviar-correo'"
        ></template>
        <template
          slot="icon"
          :icon="'fa fa-window-close'"
          :class="'btn btn-sm btn-primary'"
          :slug="'cancelar-acuerdo'"
        ></template>
        <!--template slot="icon" :icon="'fa fa-dollar'" :class="'btn btn-sm btn-primary'"></template>
                <template slot="icon" :icon="'fa fa-file-o'" :class="'btn btn-sm btn-primary dropdown-toggle'"></template-->
      </table-column>
    </table-component>
    <!-- modal de configuracion acuerdo de pago -->
    <modal class="modal" v-model="modal_acuerdo">
      <form @submit.prevent="actualizarAcuerdo()">
        <div class="row mt-2">
          <label class="col-3 control-label text-right" style="font-size: 14px">
            <strong>Día</strong>
          </label>
          <div class="col-6">
            <input type="text" class="form-control" v-model="dia_pago" />
          </div>
        </div>
        <div class="row mt-2">
          <label class="col-3 control-label text-right" style="font-size: 14px">
            <strong>Fecha primer pago</strong>
          </label>
          <div class="col-6">
            <datepicker
              v-model="date_parse"
              :format="'yyyy-MM-dd'"
              :input-class="'form-control'"
              :placeholder="'Fecha Primer Pago'"
              :language="es"
            ></datepicker>
          </div>
        </div>
      </form>
      <span slot="footer">
        <btn type="button" class="btn btn-primary" @click="resetAcuerdo()"
          >Cancelar</btn
        >&nbsp;
        <btn
          type="button"
          class="btn btn-primary"
          @click="actualizarAcuerdo()"
          >{{ "Guardar" }}</btn
        >&nbsp;
      </span>
    </modal>
    <!-- modal envio de correo -->
    <modal
      class="modal"
      v-model="modal_correo"
      :title="'Enviar correo electronico'"
    >
      <div class="loader" v-if="loading">
        <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
      </div>
      <template v-if="emails.length > 0">
        <!-- input correo -->
        <div class="form-group">
          <label class="col-md-3 control-label" for="text-input"
            >Destinatario*</label
          >
          <div class="col-md-9">
            <select name="" v-model="email.destinatario" class="form-control">
              <option value="">Seleccione una opcion</option>
              <option
                v-for="(email, index) in emails"
                :key="index"
                :value="email.valor"
              >
                {{ email.valor }}
              </option>
              <option
                :value="'Descarga local'"
              >
                {{ "Descargar Archivo" }}
              </option>
            </select>
          </div>
        </div>
        <span slot="footer">
          <btn type="button" class="btn btn-danger" @click="cerrarModalEmail()"
            >Cerrar</btn
          >&nbsp;
          <btn
            type="button"
            :disabled="
              email.destinatario.length > 0 && !  this.loading
                ? null
                : 'disabled'
            "
            class="btn btn-info"
            @click="enviarEmail()"

          >Enviar</btn>
        </span>
      </template>
      <template v-else>
        <div class="text-center">
          <h3>No tiene correos electronicos para realizar esta operación.</h3>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import FileSaver from "file-saver";
export default {
  name: "AcuerdosPago",
  data: () => {
    return {
      modal_acuerdo: false,
      modal_correo: false,
      acuerdo: null,
      dia_pago: null,
      fecha_primer_pago: null,
      date_parse: null,
      es: es,
      email: {
        destinatario: "",
      },
    };
  },
  computed: {
    ...mapGetters({ loading: "loading" }),
    acuerdos_pago() {
      return this.$store.getters["deudor/acuerdos_pago"];
    },
    emails() {
      return this.$store.getters["gestion/infoContacto"]["email"]
        ? this.$store.getters["gestion/infoContacto"]["email"]
        : [];
    },
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
    Contacto: () => import("@/views/Contacto.vue"),
    Datepicker,
  },
  methods: {
    getAcuerdos(identificacion) {
      this.$store.dispatch("deudor/refresh_acuerdos_pago", []);
      this.$store
        .dispatch("index", {
          endpoint: "acuerdo_pago",
          params: { deudor: identificacion, paginar: false },
        })
        .then((response) => {
          if (response.datos.length > 0) {
            this.$store.dispatch(
              "deudor/refresh_acuerdos_pago",
              response.datos
            );
          } else {
            this.$notify({
              title: "Advertencia!",
              type: "warning",
              content:
                "No se encontró información con el documento " + identificacion,
            });
          }
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error realizando su consulta",
          });
        });
    },
    cancelarAcuerdo(acuerdo) {
      if (acuerdo.estado == "cancelado") {
        this.$notify({
          title: "Advertencia!",
          type: "warning",
          content: "Este acuerdo ya se encuentra cancelado",
        });
      } else {
        this.$store
          .dispatch("edit", {
            endpoint: "acuerdo_pago/" + acuerdo.id,
            params: {
              ...acuerdo,
              estado: "cancelado",
              usuario_id: this.$store.state.user.user.id,
            },
          })
          .then((response) => {
            this.$notify({
              title: "Acuerdo de Pago",
              type: "success",
              content:
                "Se canceló el acuerdo de pago No " +
                response.id +
                " satisfactoriamente",
            });
            this.getAcuerdos(this.$route.params.identificacion);
          })
          .catch(() => {
            this.$notify({
              title: "Advertencia!",
              type: "warning",
              content: "Ha ocurrido un problema invalidando el acuerdo de pago",
            });
          });
      }
    },
    actualizarAcuerdo() {
      if (this.acuerdo.estado == "cancelado") {
        this.$notify({
          title: "Advertencia!",
          type: "warning",
          content: "Este acuerdo ya se encuentra cancelado",
        });
      } else {
        this.acuerdo.dia_pago = this.dia_pago;
        this.acuerdo.fecha_primer_pago = this.fecha_primer_pago;
        this.acuerdo.usuario_id = this.$store.state.user.user.id,
        this.modal_acuerdo = false;

        this.$store
          .dispatch("edit", {
            endpoint: "acuerdo_pago/" + this.acuerdo.id,
            params: this.acuerdo,
          })
          .then((response) => {
            this.$notify({
              title: "Guardado!",
              type: "success",
              content: "Se guardo el acuerdo satisfactoriamente",
            });
          })
          .catch((err) => {
            Object.values(err.data.errors).forEach((element) => {
              this.$notify({
                title: "Error!",
                type: "warning",
                duration: 0,
                content: element.join(" - "),
              });
            });
            this.getAcuerdos(this.$route.params.identificacion);
          });
      }
    },
    resetAcuerdo() {
      this.modal_acuerdo = false;
      this.dia_pago = null;
      this.fecha_primer_pago = null;
      this.date_parse = null;
      this.acuerdo = null;
    },
    cerrarModalEmail(){
      this.modal_correo = false;
      this.email.destinatario = "";
    },
    padZero(value) {
      return value < 10 ? '0' + value : value;
    },
    dateTimeNow(){
      var now = new Date();

      var year = now.getFullYear();
      var month = this.padZero(now.getMonth() + 1); // Adding 1 because months are zero-based
      var day = this.padZero(now.getDate());
      var hours = this.padZero(now.getHours());
      var minutes = this.padZero(now.getMinutes());
      var seconds = this.padZero(now.getSeconds());

      var formattedDateTime = `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;
      return formattedDateTime;
    },
    enviarEmail() {
      this.$store
        .dispatch("store", {
          endpoint: "/utilidades/enviar_documento_acuerdo_pago",
          params:  {
            acuerdo: this.acuerdo,
            destinatario: this.email.destinatario
          },
          config: {
            responseType: "arraybuffer",
          },
        })
        .then((response) => {
          if(this.email.destinatario == "Descarga local"){
            let nombre_archivo = this.$route.params.identificacion + '_acuerdopago_' + this.dateTimeNow() + '.pdf';
            var blob = new Blob([response], {
              type: "application/pdf;charset=utf-8",
            });
            FileSaver.saveAs(
              blob,
              nombre_archivo
            );
            this.$notify({
              title: "Descarga correcta!",
              type: "success",
              content: "El archivo se ha descargado con exito.",
            });
          }else{
            this.$notify({
              title: "Enviado!",
              type: "success",
              content: "Correo enviado con exito.",
            });
          }
          this.cerrarModalEmail();
        })
        .catch((error) => {
          if(this.email.destinatario == "Descarga local"){
            this.$notify({
              title: "Error!",
              type: "warning",
              content:
                "Se presento un error a la hora de descargar el archivo.",
              duration: 0,
            });
          }else{
            this.$notify({
              title: "Error!",
              type: "warning",
              content:
                "Se presento un error a la hora de enviar el correo.",
              duration: 0,
            });
          }
        });
    },
    clickEvent(data, slug) {
      switch (slug) {
        case "cancelar-acuerdo":
          this.cancelarAcuerdo(data);
          break;
        case "editar-acuerdo":
          this.dia_pago = data.dia_pago;
          this.date_parse = data.fecha_primer_pago;
          this.acuerdo = data;
          this.modal_acuerdo = true;
          break;
        case "enviar-correo":
          this.modal_correo = true;
          this.acuerdo = data;
          break;
      }
    },
  },
  watch: {
    date_parse: function(newVal) {
      this.fecha_primer_pago = this.$moment(newVal).format("YYYY-MM-DD");
    },
  },
  mounted() {
    this.getAcuerdos(this.$route.params.identificacion);
  },
};

</script>
